import {
  Box,
  Flex,
  GreyGrey60,
  GreyGrey80,
  InputSelectControlField,
  Primary13Regular,
  SimpleModal
} from '@sequencehq/core-components'
import { FC } from 'react'
import { useLinkHubSpotDealModal } from './useLinkHubSpotDealModal'

export const LinkHubSpotDealModal: FC<{
  companyId: string
  quoteId: string
  onLink: () => void
  onClose: () => void
}> = props => {
  const hook = useLinkHubSpotDealModal({
    companyId: props.companyId,
    quoteId: props.quoteId,
    onConfirm: props.onLink
  })

  const showNoDealsMessage = hook.loaded && !hook.hasDeals

  return (
    <SimpleModal
      isOpen
      onClose={props.onClose}
      data-testid="hubspot.deal.link.modal"
      title="Link quote to a HubSpot deal"
      isLoading={!hook.loaded}
      submitButtonText="Create link"
      submittingButtonText="Creating link..."
      cancelButtonText="Cancel"
      submitDisabled={hook.submit.disabled}
      submitting={hook.submit.linking}
      onSubmit={hook.submit.onClick}
      minHeight="0px"
    >
      <Flex
        color={GreyGrey80}
        {...Primary13Regular}
        flexDirection="column"
        gap="16px"
      >
        <InputSelectControlField
          {...hook.fields.linkToDeal}
          label="HubSpot deal"
          data-testid="linkToDeal"
          placeholder="Select HubSpot deal"
          disabled={!hook.hasDeals}
        />
        {showNoDealsMessage && (
          <Box
            {...Primary13Regular}
            color={GreyGrey60}
            data-testid="hubspot.deal.link.modal.noDeals"
          >
            This company has no deals in the pipeline stages configured on your
            HubSpot integration.
          </Box>
        )}
        {hook.isTruncated && (
          <Box
            {...Primary13Regular}
            color={GreyGrey60}
            data-testid="hubspot.deal.link.modal.truncated"
          >
            Showing the most recently changed deals only. This company has more
            deals than we can list here.
          </Box>
        )}
      </Flex>
    </SimpleModal>
  )
}
